import React from 'react'

type Props = {}

const MoviePage = (props: Props) => {
    return (
        <>
            
        </>
    )
}

export default MoviePage